<cx-searchbox id="returnsearch" [returnSearch]='true'  [searchValueClear]="clearSearchValue"
     (selectedProductEvent)="onProductSelected($event)"  [config]='QUICKORDER_SEARCH_BOX_CONFIG'
    [returnSearchPlaceholder]='placeholderText'>
</cx-searchbox>